import { render, staticRenderFns } from "./HealthChart.vue?vue&type=template&id=5ae7958c&scoped=true"
import script from "./HealthChart.vue?vue&type=script&lang=js"
export * from "./HealthChart.vue?vue&type=script&lang=js"
import style0 from "./HealthChart.vue?vue&type=style&index=0&id=5ae7958c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae7958c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ae7958c')) {
      api.createRecord('5ae7958c', component.options)
    } else {
      api.reload('5ae7958c', component.options)
    }
    module.hot.accept("./HealthChart.vue?vue&type=template&id=5ae7958c&scoped=true", function () {
      api.rerender('5ae7958c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inspect/HealthChart.vue"
export default component.exports